var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvalanche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1501 48C37.405 48 48.1501 37.2548 48.1501 24C48.1501 10.7452 37.405 0 24.1501 0C10.8953 0 0.150146 10.7452 0.150146 24C0.150146 37.2548 10.8953 48 24.1501 48Z",
    fill: "#E44142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6166 24.6236C33.4481 23.1874 34.7898 23.1874 35.6213 24.6236L40.7992 33.7134C41.6307 35.1496 40.9504 36.3213 39.2874 36.3213H28.8559C27.2118 36.3213 26.5315 35.1496 27.3441 33.7134L32.6166 24.6236ZM22.6008 7.12441C23.4323 5.68819 24.7551 5.68819 25.5866 7.12441L26.7394 9.20315L29.4607 13.9842C30.1221 15.3449 30.1221 16.9512 29.4607 18.3118L20.3331 34.1291C19.5016 35.4142 18.1221 36.2268 16.5914 36.3213H9.01342C7.35042 36.3213 6.67011 35.1685 7.50161 33.7134L22.6008 7.12441Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/Avalanche.51f57b8fd78088648e3a5773df0f463f.svg";
export { ForwardRef as ReactComponent };